// The final feedback in the admin (30.10.2026): the words the team reads.
// Validated in docs/texte-feedback-final-2026-10-30.md, part 10.
import { shortDay } from "./initialAssessment";

export const SWITCH_TITLE = "Trimite automat chestionarul de feedback.";
export const SWITCH_HINT =
  "La 2 ore după ultima sesiune, cursanții care nu au completat primesc chestionarul de feedback pe email, între orele "
  + "08 și 21, plus o reamintire după 2 zile. Se închide după 7 zile. Pe fiecare grupă alegi dacă se trimite automat.";

export const MODES = [
  { key: "automat", label: "Automat", hint: "linkul la formator, plus emailul după ultima sesiune și o reamintire." },
  { key: "trainer", label: "Doar prin formator",
    hint: "linkul la formator, fără emailuri automate. Îl poți trimite tu din fișa grupei." },
  { key: "external", label: "Nu prin platformă", hint: "grupa dă feedbackul în altă parte, de exemplu în Google Forms." },
];

export const modeWord = (key) => MODES.find((m) => m.key === key)?.label || "";

export const startedNote = (firstSession) =>
  `Grupa a început pe ${shortDay(firstSession)}. Dacă vrei să primească formularul, alege „Automat” sau „Doar prin formator”.`;

export const countLine = (data) =>
  `${data.answered} din ${data.people} au răspuns`
  + (data.deadline ? ` · ${data.closed ? "s-a închis" : "se închide"} pe ${shortDay(data.deadline)}` : "");

export const sendLabel = (n) => `Trimite chestionarul de feedback celor care n-au răspuns (${n})`;
export const sendQuestion = (n, deadline) =>
  `Trimiți chestionarul de feedback către ${n} ${n === 1 ? "cursant" : "cursanți"}? Îl pot completa până la ${shortDay(deadline)}.`;
export const reopenLabel = (n) => `Redeschide pentru toți cei care lipsesc (${n})`;
export const reopenQuestion = (n, day) =>
  `Redeschizi chestionarul de feedback pentru ${n} ${n === 1 ? "cursant și îi trimiți un link nou" : "cursanți și le trimiți câte un link nou"}, `
  + `cu termen până la ${shortDay(day)}. Poți schimba termenul.`;
